module.exports = __webpack_public_path__ + "img/noorder.243bd7d4.png";